<template>
  <div class="container">
    <div class="header">
      <div class="total">
        <div>总资产(元)</div>
        <div v-if="balance.now_money">
          {{ balance.now_money.split(".")[0] || 0
          }}<span>.{{ balance.now_money.split(".")[1] || 0 }}</span>
        </div>
      </div>
      <div class="sale">
        <div>
          累计消费(元):<span>{{ balance.orderStatusSum || 0 }}</span>
        </div>
        <div>
          累计充值(元):<span>{{ balance.recharge || 0 }}</span>
        </div>
      </div>
      <div class="btn">
        <div class="button" @click="rechange">充值</div>
      </div>
    </div>
    <Tabs active-key="key1" @on-click="changeTab">
      <Tab-pane label="账单记录" key="key1">
        <div class="content-item">
          <div
            class="project-item"
            v-for="item of allOrderRecode"
            :key="item.time"
          >
            <div class="title">{{ item.time }}</div>
            <div
              class="project-list"
              v-for="product of item.list"
              :key="product.add_time"
            >
              <div class="item">
                <span>{{ product.title }}</span>
                <span>{{ product.add_time }}</span>
                <span class="money" v-if="product.pm === 0"
                  >-{{ product.number }}</span
                >
                <span v-else class="money-add">+{{ product.number }}</span>
              </div>
            </div>
          </div>
        </div>
      </Tab-pane>
      <Tab-pane label="消费记录" key="key2">
        <div class="content-item">
          <div
            class="project-item"
            v-for="item of expensesRecord"
            :key="item.time"
          >
            <div class="title">{{ item.time }}</div>
            <div
              class="project-list"
              v-for="product of item.list"
              :key="product.add_time"
            >
              <div class="item">
                <span>{{ product.title }}</span>
                <span>{{ product.add_time }}</span>
                <span class="money" v-if="product.pm === 0"
                  >-{{ product.number }}</span
                >
                <span v-else class="money-add">+{{ product.number }}</span>
              </div>
            </div>
          </div>
        </div>
      </Tab-pane>
      <Tab-pane label="充值记录" key="key3">
        <div class="content-item">
          <div
            class="project-item"
            v-for="item of rechargeRecord"
            :key="item.time"
          >
            <div class="title">{{ item.time }}</div>
            <div
              class="project-list"
              v-for="product of item.list"
              :key="product.add_time"
            >
              <div class="item">
                <span>{{ product.title }}</span>
                <span>{{ product.add_time }}</span>
                <span class="money" v-if="product.pm === 0"
                  >-{{ product.number }}</span
                >
                <span v-else class="money-add">+{{ product.number }}</span>
              </div>
            </div>
          </div>
        </div>
      </Tab-pane>
      <Tab-pane label="积分中心" key="key4">
        <div class="integral-box">
          <div class="first">
            <div>当前积分</div>
            <img src="../../../assets/pc/images/home/jifen-icon.png" alt="" />
            <div>{{ Number(info.integral) }}</div>
          </div>
          <div class="item">
            <div>累计积分</div>
            <span>{{ info.sum_integral }}</span>
          </div>
          <div class="item">
            <div>累计消费</div>
            <span>{{ info.deduction_integral }}</span>
          </div>
          <div class="item">
            <div>今日获得</div>
            <span>{{ info.today_integral }}</span>
          </div>
        </div>
        <div class="detail-list">
          <div
            class="tab"
            :class="integralActive === 0 ? 'active' : ''"
            @click="integralActive = 0"
          >
            分值明细
          </div>
          <div
            class="tab"
            :class="integralActive === 1 ? 'active' : ''"
            @click="integralActive = 1"
          >
            分值提升
          </div>
        </div>
        <div class="content-list">
          <div class="project" v-if="integralActive === 0">
            <div
              class="item"
              v-for="(item, index) of integeralInfo"
              :key="index"
            >
              <div>{{ item.mark }}</div>
              <div>{{ item.add_time }}</div>
              <div class="integeral-num" v-if="item.pm == 1">
                +{{ item.number }}
              </div>
              <div class="integeral-num red" v-else>-{{ item.number }}</div>
            </div>
          </div>
          <div v-else class="project-add">
            购买药品可获得积分奖励
          </div>
        </div>
      </Tab-pane>
    </Tabs>
    <div class="mask" v-if="maskShow">
      <div class="content">
        <div class="icon" @click="maskShow = false">
          <Icon type="close-circled" class="close"></Icon>
        </div>
        <div class="tab-item">
          <div
            class="item"
            :class="active === 0 ? 'active' : ''"
            @click="changActive(0)"
          >
            账户充值
          </div>
          <div
            class="item"
            :class="active === 1 ? 'active' : ''"
            @click="changActive(1)"
          >
            佣金导入
          </div>
        </div>
        <div class="money">
          <span>￥</span>
          <input type="text" placeholder="0.00" v-model="price" />
        </div>
        <div class="tip">
          <div v-if="active === 0">
            提示：当前余额为
            <span>￥{{ balance.now_money || 0 }}</span>
          </div>
          <div v-else>
            提示：当前佣金为
            <span>￥{{ userInfo.brokerage_price || 0 }}</span>
          </div>
        </div>
        <div class="btn">
          <i-button
            @click="rechargeMoney"
            type="error"
            shape="circle"
            size="large"
            long
            class="btn-confirm"
            :loading="loading"
          >
            立即充值
          </i-button>
        </div>
      </div>
      <div class="pay" v-if="payMask">
        <div class="icon-close">
          <Icon type="close-circled" class="close" @click="payClose"></Icon>
        </div>
        <div class="title">
          <p>请用手机微信扫下方的二维码进行支付</p>
          <div>
            二维码有效期还剩下
            <span>{{ hours }}</span
            >: <span>{{ minute }}</span
            >:
            <span>{{ second }}</span>
          </div>
        </div>
        <div class="img-box">
          <img :src="codeImg" alt="" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  getBalance,
  getCommissionInfo,
  rechargeWechat,
  postSignUser,
  getIntegralList
} from "@api/user";
import { rechargeOrder } from "@api/order";
import { mapState } from "vuex";
export default {
  name: "MyBalance",
  data() {
    return {
      balance: {},
      allOrderRecode: [],
      expensesRecord: [],
      rechargeRecord: [],
      maskShow: false,
      payMask: false,
      active: 0,
      price: "",
      hours: 0,
      minute: 0,
      second: 0,
      endtime: "",
      codeImg: "",
      orderId: "", // 生成二维码时的订单编号
      loading: false,
      data: {
        // 获取积分参数
        sign: 1,
        integral: 1,
        all: 1
      },
      info: {},
      integeralInfo: [],
      integralParam: {
        page: 1,
        limit: 15
      },
      integralActive: 0
    };
  },
  computed: {
    ...mapState(["userInfo"])
  },
  created() {
    this.getBalanceInfo();
    this.getOrderMession(0);
  },
  destroyed() {
    clearInterval(this.myInterval);
  },
  methods: {
    getBalanceInfo() {
      getBalance()
        .then(res => {
          if (res.status === 200) {
            this.balance = res.data;
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    getOrderMession(types) {
      const q = {
        page: 1,
        limit: 5
      };
      getCommissionInfo(q, types).then(res => {
        if (res.status === 200) {
          if (types === 0) {
            this.allOrderRecode = res.data;
          } else if (types === 1) {
            this.expensesRecord = res.data;
          } else {
            this.rechargeRecord = res.data;
          }
        }
      });
    },
    changeTab(key) {
      if (key === 3) {
        postSignUser(this.data).then(res => {
          if (res.status === 200) {
            this.info = res.data;
          }
        });
        getIntegralList(this.integralParam).then(res => {
          this.integeralInfo = res.data;
        });
      } else {
        this.getOrderMession(key);
      }
    },
    rechange() {
      this.maskShow = true;
    },
    // 充值切换
    changActive(index) {
      this.active = index;
    },
    // 充值提交
    rechargeMoney() {
      const price = Number(this.price);
      if (price === 0) {
        this.$Message.info("请输入您要转入的金额");
        return;
      } else if (price < 0.02) {
        this.$Message.info("转入金额不能低于0.02");
        return;
      } else if (isNaN(price)) {
        this.$Message.info("请输入有效的金额");
        this.price = "";
        return;
      }
      this.loading = true;
      if (this.active === 0) {
        rechargeWechat({ price: price, from: "weixinpc" })
          .then(res => {
            if (res.status === 200) {
              this.loading = false;
              this.payMask = true;
              const nowtime = new Date(); // 获取当前时间
              this.endtime = new Date(nowtime.setHours(nowtime.getHours() + 1)); // 定义结束时间
              this.showtime();
              this.codeImg =
                "https://www.atropin.cn/" + res.data.data.results.codeUrl;

              this.orderId = res.data.data.results.order_id;
              // 轮询是否付款成功
              this.myInterval = window.setInterval(() => {
                this.waitPay(); // 调用接口的方法
              }, 2000);
            }
          })
          .catch(err => {
            this.loading = false;
            console.log(err.msg);
          });
      } else {
        rechargeWechat({ price: price, from: "weixinh5", type: 1 })
          .then(res => {
            this.loading = false;
            if (res.status === 200) {
              this.$Message.success("转入余额成功");
            }
          })
          .catch(err => {
            this.loading = false;
            console.log(err.msg);
          });
      }
    },
    // 一个小时倒计时
    showtime() {
      const nowtime = new Date(); // 获取当前时间
      const lefttime = this.endtime.getTime() - nowtime.getTime(); // 距离结束时间的毫秒数
      if (lefttime >= 0) {
        const hours = Math.floor((lefttime / (1000 * 60 * 60)) % 24); // 计算小时数
        this.hours = hours < 10 ? "0" + hours : hours;
        const minute = Math.floor((lefttime / (1000 * 60)) % 60); // 计算分钟数
        this.minute = minute < 10 ? "0" + minute : minute;
        const second = Math.floor((lefttime / 1000) % 60); // 计算秒数
        this.second = second < 10 ? "0" + second : second;
        setTimeout(this.showtime, 1000);
      }
    },
    // 充值付款是否成功的回调
    waitPay() {
      rechargeOrder(this.orderId)
        .then(res => {
          const paid = res.data.paid;
          if (paid === 1) {
            this.$Modal.success({
              content: "付款成功"
            });
            this.payMask = false;
            clearInterval(this.myInterval);
          }
        })
        .catch(err => {
          this.$Modal.warning({
            content: err.msg
          });
        });
    },
    payClose() {
      this.payMask = false;
      clearInterval(this.myInterval);
    }
  }
};
</script>

<style lang="stylus" scoped>
.container /deep/ .ivu-tabs-tab
  width 150px
  text-align center
.container
  width 800px
  .header
    display flex
    background-image url('../../../assets/pc/images/home/sale_bg.png')
    background-size 640px 120px
    background-repeat no-repeat
    background-position 0 80px
    .total
      margin-left 40px
      margin-top 60px
      margin-bottom 90px
      width 300px
      div:first-child
        font-size 16px
        margin-bottom 10px
      div:last-child
        font-size 30px
        line-height 30px
        font-weight 700
        span
          font-size 18px
    .sale
      margin-top 70px
      font-size 12px
      width 300px
      div
        line-height 24px
        span
          margin-left 10px
          font-size 16px
          font-weight 700
          color #333
    .btn
      margin-top 70px
      .button
        width 250px
        height 50px
        line-height 50px
        font-size 16px
        border-radius 4px
        text-align center
        background #ff4341
        color #fff
        cursor pointer
  .content-item
    .project-item
      margin-bottom 10px
      .title
        font-size 18px
        color #333
      .project-list
        margin-left 30px
        .item
          display flex
          width 460px
          justify-content space-between
          font-size 14px
          line-height 24px
          color #666
          span
            width 33%
            text-align left
          span:last-child
            text-align right
          .money
            color red
          .money-add
            color #16ac57
  .integral-box
    margin 10px 0
    display flex
    align-items center
    text-align center
    padding-bottom 30px
    border-bottom 1px solid #eee
    .first
      margin-left 50px
      font-size 16px
      border-right 1px solid #eee
      padding-right 80px
      div:first-child
        margin-bottom 20px
      div:last-child
        font-size 20px
        font-weight 700
        margin-top 5px
    .item
      width 160px
      span
        font-size 20px
  .detail-list
    display flex
    margin-top 30px
    .tab
      width 120px
      cursor pointer
      line-height 30px
      text-align center
      font-size 14px
      border 1px solid #fbdcdd
      border-radius 15px
      margin-right 20px
      background #fff5f1
      color #ff4341
      &.active
        background #ff4341
        font-weight 700
        color #fff
        border 0
  .content-list
    margin 10px 50px
    .project
      .item
        display flex
        div
          width 23%
          font-size 14px
        .integeral-num
          color #16ac57
          &.red
            color #f00
    // .project-add
    //   width 50%
    //   transform translateX(100%)
    //   font-size 14px

  .mask
    position fixed
    top 0
    background rgba(0, 0, 0, .5)
    left 0
    right 0
    bottom 0
    z-index 1000
    display flex
    align-items center
    justify-content center
    .content
      width: 400px;
      height: 250px;
      background: #fff;
      padding: 30px;
      border-radius: 8px;
      text-align center
      position relative
      .icon
        position absolute
        top 10px
        right 10px
        cursor pointer
        .close
          font-size 20px
      .tab-item
        display flex
        justify-content space-between
        padding 0 40px
        font-size 16px
        margin-bottom 40px
        .item
          cursor pointer
          width 100px
          transition all 0.5s
          position relative
          &:after
            content ''
            display inline
            position absolute
            top 35px
            left 0
            width 0
            height 2px
            background red
            transition all 0.5s
          &.active
            font-weight 700
          &.active:after
            width 100%
      .money
        border-bottom 1px dashed #ccc
        padding-bottom 20px
        span
          color #333
          font-size 22px
          font-weight 700
          padding 0 10px
        input
          border 0
          outline 0
          font-size 28px
          width 100px
      .tip
        color #999
        margin-top 5px
        span
          color #ef4a49
      .btn
        margin-top 20px
        padding 0 20px
        .btn-confirm
          font-size 16px
          font-weight 700
    .pay
      width 400px
      height 400px
      background #fff
      position absolute
      text-align center
      .title
        font-size 16px
        margin 20px 0 10px
        div
          color #999
          font-size 14px
          margin-top 5px
          span
            color #ef4a49
            margin-right 5px
      .img-box
        margin 0 auto
        width 300px
        height 300px
        img
         width 100%
      .icon-close
        position absolute
        right 10px
        top 10px
        .close
          font-size 20px
</style>
